import React, { useEffect, useState } from 'react';
import * as ReactDOM from 'react-dom';
import { useDispatch, useSelector, useStore } from 'react-redux';
import { useIntl } from 'react-intl';
import { NavLink } from 'react-router';
import moment from 'moment';
import { Icons, Row } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import {
  dateFormatter,
  infoFormatterIntl,
  carrierStatusFormatter, infoFormatter, federalFawFormatter,
} from '../../../utils/formatters';
import { getRegisterData } from '../reducer';
import {
  APPLICATION_STATUS, REGION_REGISTRY_RELATION, USER_TYPE,
} from '../../../configs';
import { responseLogWithNotification } from '../../../utils/utils';
import Switches from '../../../components/fields/Switches/Switches';
import RecipientView from './RecipientView';
import Loader from '../../../components/base/Loader/Loader';
import VehiclesMiniGrid from './VehiclesMiniGrid';
import SZLTMiniGrid from './SZLTMiniGrid';
import DocumentList from '../../Application/components/DocumentList';
import { RegistryRelationHistoryDialog } from './RegistryRelationHistoryDialog';
import OsgopInsuranceView from '../../Application/components/ViewBlocks/OsgopInsuranceView';
import RegistryPageModal from './RegistryPageModal';
import ApplicationLegend from '../../Application/components/ApplicationLegend';
import AccordionWithPreview from '../../../components/base/Accordion/AccordionWithPreview';

export default function CarrierView(props) {
  const { formatMessage } = useIntl();
  const {
    onClose = () => {}, handleEdit = () => {}, loadData = () => {}, formMeta,
  } = props;
  const [isHistoryPopUp, setIsHistoryPopUp] = useState(false);
  const [isSameRegistryPopUp, setIsSameRegistryPopUp] = useState(false);
  const {
    currentCarrier = {},
    loadingCheckAllCarrier,
  } = useSelector(getRegisterData);

  const {
    osgop_insurances = [],
    legal_entity_type = 0,
    id = '',
  } = currentCarrier;

  return ReactDOM.createPortal(
    <div className="application-form">
      <Loader loading={loadingCheckAllCarrier} />
      <div className="application-form-header">
        <div className="breadcrumbs">
          <span className="breadcrumbs-prev">Реестры</span>
          <Icons width={22} height={22} customIcon icon="arrow-right" className="breadcrumbs-arrow" />
          <span className="breadcrumbs-prev">Реестр перевозчиков</span>
          <Icons width={22} height={22} customIcon icon="arrow-right" className="breadcrumbs-arrow" />
          <span className="breadcrumbs-prev">Разрешение</span>
          <Icons width={22} height={22} customIcon icon="arrow-right" className="breadcrumbs-arrow" />
          <span className="breadcrumbs-current">Разрешение перевозчика № {currentCarrier?.number || 'Без номера'} (просмотр)</span>
        </div>
        <div className="legend-button">
          <Icons width={24} height={24} customIcon icon="helper" />
          <ApplicationLegend />
        </div>
        <div className="close-button" onClick={onClose}>
          <Icons width={24} height={24} customIcon icon="close" />
        </div>
      </div>
      <div className="application-form-body application-form-view szlt-registry">
        <div className="application-form-body-wrapper">
          <div className="application-form-content">
            <div className="application-form-fields">
              <div className="application-form-fields-wrapper custom-scroll-theme">
                <div className="afc-header">
                  Разрешение перевозчика №{currentCarrier.number}
                  {carrierStatusFormatter(currentCarrier.status)}
                  {federalFawFormatter(currentCarrier?.federal_law_number)}
                  <div className="afc-header-link">
                    <div className="afc-header-link-same">
                      <Icons
                        customIcon
                        icon="same-registry"
                        onClick={() => setIsSameRegistryPopUp(true)}
                      />
                    </div>
                    <NavLink
                      to={{
                        pathname: '/application',
                        search: new URLSearchParams({
                          filter: 'carrier',
                          number: currentCarrier.number,
                          status: Object.values(APPLICATION_STATUS),
                          created_at: [moment(currentCarrier.created_at).subtract(1, 'year').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')],
                        }).toString(),
                      }}
                      target="_blank"
                    >
                      <Icons
                        customIcon
                        icon="show-relation-link"
                      />
                    </NavLink>
                  </div>
                </div>
                <div className="afc-body">
                  <div className="afc-main">
                    <Row className="row-cols-2">
                      {infoFormatterIntl('registry.number', currentCarrier.number, formMeta, 'number')}
                      {infoFormatterIntl('registry.created_at', dateFormatter(currentCarrier.created_at), formMeta, 'created_at')}
                    </Row>
                    <Row className="row-cols-2">
                      {infoFormatterIntl('effective_date', dateFormatter(currentCarrier.effective_date), formMeta, 'effective_date')}
                      {infoFormatterIntl('expiration_date', dateFormatter(currentCarrier.expiration_date), formMeta, 'expiration_date')}
                    </Row>
                    {
                      [APPLICATION_STATUS.SUSPENDED, APPLICATION_STATUS.CHECKING].includes(currentCarrier.status) ? (
                        <Row className="row-cols-3">
                          {infoFormatter('Основание', currentCarrier?.rejection_reason_messages?.[0]?.name || '')}
                          {infoFormatter('Дополнительное основание', currentCarrier?.rejection_reason_messages?.[0]?.additional_message || '')}
                          {infoFormatter('Комментарий', currentCarrier?.rejection_reason_messages?.[0]?.message || '')}
                        </Row>
                      ) : null
                    }
                    <RecipientView current={currentCarrier} formMeta={formMeta} />
                    <div className="hr-row" />
                    <div className="f4">Информация о водителе</div>
                    {
                      [USER_TYPE.PRIVATE_PERSON, USER_TYPE.INDIVIDUAL_ENTREPRENEUR].includes(legal_entity_type) ? (
                        <>
                          <Switches
                            inputProps={{
                              value: currentCarrier.has_employees,
                              onChange: () => {
                              },
                            }}
                            label={formatMessage({ id: 'has_employees' })}
                          />
                          <Row className="row-cols-2">
                            {infoFormatterIntl('driver_license_series', currentCarrier.driver_license_series, formMeta, 'driver_license_series')}
                            {infoFormatterIntl('driver_license_number', currentCarrier.driver_license_number, formMeta, 'driver_license_number')}
                          </Row>
                          <Row className="row-cols-2">
                            {infoFormatterIntl('driver_license_issue_date', dateFormatter(currentCarrier.driver_license_issue_date), formMeta, 'driver_license_issue_date')}
                            {infoFormatterIntl('driver_license_expiration_date', dateFormatter(currentCarrier.driver_license_expiration_date), formMeta, 'driver_license_expiration_date')}
                          </Row>
                          <div className="hr-row" />
                        </>
                      ) : null
                    }
                    <Row className="row-cols-1">
                      {infoFormatterIntl('medical_examination_address', currentCarrier.medical_examination_address, formMeta, 'medical_examination_address')}
                    </Row>
                    <div className="f4">Дополнительная информация</div>
                    <Row className="row-cols-2">
                      {infoFormatterIntl('decision', currentCarrier.decision, formMeta, 'decision')}
                      {infoFormatterIntl('decision_date', dateFormatter(currentCarrier.decision_date), formMeta, 'decision_date')}
                    </Row>
                    <Row className="row-cols-2">
                      {infoFormatterIntl('commercial_name', currentCarrier.commercial_name, formMeta, 'commercial_name')}
                      {infoFormatterIntl('logo_files', currentCarrier.logo_files, formMeta, 'logo_files')}
                    </Row>
                    {[USER_TYPE.PRIVATE_PERSON].includes(legal_entity_type) ? (
                      <>
                        <Row className="row-cols-1">
                          {infoFormatterIntl('carriage_contract_number', currentCarrier.carriage_contract_number, formMeta, 'carriage_contract_number')}
                        </Row>
                        <Row className="row-cols-3">
                          {infoFormatterIntl('carriage_contract_expiration_date', dateFormatter(currentCarrier.carriage_contract_expiration_date), formMeta, 'carriage_contract_expiration_date')}
                          {infoFormatterIntl('carriage_contract_effective_date', dateFormatter(currentCarrier.carriage_contract_effective_date), formMeta, 'carriage_contract_effective_date')}
                        </Row>
                      </>
                    ) : null}
                    <div className="f4 mt-3">Информация по ОСГОП перевозчика</div>
                    {Array.isArray(osgop_insurances) ? (
                      osgop_insurances.map((field, index) => (
                        <div key={index} className="mt-3">
                          <OsgopInsuranceView
                            data={field}
                            labelPrefix="osgop_"
                            prefix="osgop_insurances."
                          />
                          {osgop_insurances.length - 1 !== index ? <div className="hr-row" /> : null}
                        </div>
                      ))
                    ) : (
                      <OsgopInsuranceView
                        data={currentCarrier}
                        labelPrefix="osgop_"
                        prefix="osgop_insurance."
                      />
                    )}
                    {/* <div className="hr-row" /> */}
                    {/* <div className="f4">Реестр ЛТ</div> */}
                    {/* <div className="vehicles-block"> */}
                    {/*  {vehicles.map((item, index) => { */}
                    {/*    const statusClass = !Number.isNaN(item.status) ? VEHICLES_STATUS_NAMES[Number(item.status)] || 'denied' : 'denied'; */}
                    {/*    return ( */}
                    {/*      <div key={index} className={classNames('application-status', statusClass)}> */}
                    {/*        <div className="application-status-icon"> */}
                    {/*          <Icons width={30} height={30} customIcon icon={statusClass} className="button-icons" /> */}
                    {/*        </div> */}
                    {/*        Запись №{item.number} */}
                    {/*        /!* <Icons width={16} height={16} customIcon icon="close" className="button-icons" /> *!/ */}
                    {/*      </div> */}
                    {/*    ); */}
                    {/*  })} */}
                    {/* </div> */}
                    <AccordionWithPreview
                      title="Документы"
                      content={(
                        <DocumentList
                          id={currentCarrier?.id}
                          loadData={loadData}
                        />
                      )}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="application-form-content afc-right">
            <VehiclesMiniGrid
              params={{
                carrier_id: currentCarrier.id,
              }}
              setIsHistoryPopUp={setIsHistoryPopUp}
            />
            <SZLTMiniGrid
              params={{
                carrier_id: currentCarrier.id,
              }}
              setIsHistoryPopUp={setIsHistoryPopUp}
            />
          </div>
          {isHistoryPopUp ? (
            <RegistryRelationHistoryDialog
              currentCarrier={currentCarrier}
              subject_type="carrier"
              subject_id={id}
              log_name={isHistoryPopUp === 'vehicle' ? REGION_REGISTRY_RELATION.CARRIER_VEHICLE : REGION_REGISTRY_RELATION.CARRIER_SERVICE}
              onClose={() => setIsHistoryPopUp(false)}
            />
          ) : null}
          {isSameRegistryPopUp
            ? (
              <RegistryPageModal
                type="carrier"
                onClose={() => setIsSameRegistryPopUp(false)}
                customFilter={{
                  inn: currentCarrier?.inn,
                }}
                filterName="carrier-same-list-modal-filter"
                title="Реестровые записи в отношении данного перевозчика"
              />
            ) : null}
        </div>
      </div>
    </div>,
    document.getElementById('app-content'),
  );
}
